import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Checkbox, Col, FormGroup, Row} from 'react-bootstrap';
import {actions, Control, Errors, Form} from 'react-redux-form';
import RequiredSelect from '../common/form/elements/required-select';
import RewardChartWithCaption from '../common/outlet/reward-chart-with-caption';
import ArrowButton from '../common/button-arrow';
import {saveStaffRewards} from '../../actions/staff';
import t from '../../data/translations';

class ManageRewards extends Component {
  onRewardsUpdated = (payload) => {
    this.props.dispatch(actions.submitFields('deep.staff_rewards', saveStaffRewards(payload, this.props.storeId)));
  };

  render() {
    // eslint-disable-next-line react/jsx-one-expression-per-line
    let form = <h2>Loading...</h2>;
    const {
      autoRedeem, availableVoucherDenominations, availableVoucherTypes, fetched, rewardMarkup, selectedVoucherType
    } = this.props;
    if (fetched) {
      form = (
        <div className="manage-staff-rewards-form">
          <Form model="deep.staff_rewards" onSubmit={this.onRewardsUpdated}>
            <Errors className="errors" model="deep.staff_rewards"/>
            <Row>
              <Col lg={6}>
                <Row>
                  <Col lg={12}>
                    <p>
                      Currently, the points this store earns will be split as indicated below. To amend this, please contact us.
                    </p>
                  </Col>
                </Row>
                <RewardChartWithCaption rewardMarkup={rewardMarkup}/>
              </Col>
              <Col lg={6}>
                <FormGroup>
                  <Control.checkbox
                    component={Checkbox}
                    model="deep.staff_rewards.auto_redeem"
                  >
                    { t('staffRewards.autoRedeem') }
                  </Control.checkbox>
                </FormGroup>

                <RequiredSelect
                  model=".voucher_type_id"
                  values={availableVoucherTypes}
                  label="I would like to reward my staff with the following vouchers..."
                  labelAttr='label'
                  valueAttr='value'
                  controlId="voucher_type_id"
                />


                {
                  autoRedeem === true && (
                    <RequiredSelect
                      model=".voucher_denomination_id"
                      values={availableVoucherDenominations[selectedVoucherType] || []}
                      label={t('staffRewards.denomination')}
                      labelAttr='label'
                      valueAttr='value'
                      controlId="voucher_denomination_id"
                    />
                  )}
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <ArrowButton
                  className="pull-right"
                  color="grey"
                  disabled={false}
                >
                  Save changes
                </ArrowButton>
              </Col>
            </Row>
          </Form>
        </div>
      );
    }

    return (this.props.open && (
      <Col md={12}>
        {form}
      </Col>
    ));
  }
}

const mapStateToProps = state => ({
  storeId: state.staff.staffRewards.manageStoreId,
  fetched: state.staff.staffRewards.manageFetched,
  rewardMarkup: state.staff.staffRewards.rewardMarkup,
  availableVoucherTypes: state.staff.staffRewards.availableVoucherTypes,
  selectedVoucherType: state.deep.staff_rewards.voucher_type_id,
  autoRedeem: state.deep.staff_rewards.auto_redeem,
  availableVoucherDenominations: state.staff.staffRewards.availableVoucherDenominations || [],
  selectedVoucherDenomination: state.deep.staff_rewards.voucher_denomination_id
});

export default connect(mapStateToProps)(ManageRewards);



// WEBPACK FOOTER //
// ./src/components/staff-rewards/manage-rewards.jsx